function formatE164Phone() {
	return function(input) {
		if(!input) {
			return input; 
		}
      
		const cleaned = input.substring(3);

		return `(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
	};
}

function parseIntoE164Phone() {
	return {
		restrict: "A",
		require: "ngModel",
		link: function(scope, element, attrs, ngModel) {
			ngModel.$parsers.push(function(value) {
				if(!value) {
					return value; 
				}

				const cleaned = value.replace(/\D/g, "");
				if(cleaned.length === 10) {
					return "+1 " + cleaned;
				}

				return value;
			});

			ngModel.$formatters.push(function(value) {
				if(!value) {
					return value; 
				}

				const cleaned = value.substring(3);
				
				return `(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
			});
		}	
	};
}

export default angular
	.module("vesl.filters.formatE164Phone", [])
	.filter("formatE164Phone", formatE164Phone)
	.directive("phoneNumber", parseIntoE164Phone)
	.name;